<template>

  <el-dialog
    title="添加桌号"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
  <el-form size="small" ref="form" :model="form" label-width="180px">
    <table border="0" align="center" show-overflow-tooltip="true" cellpadding="2" cellspacing="12" class="" >
        
        <tr>
            <th class="tc" >名称</th>
            <th class="tc" >桌子人数</th>
            <th  class="tc">操作</th>
        </tr>
        
        <tr v-for="(item, index) in tableData" :key="index">
            <td><el-input size="small" v-model="item.name" type="text" placeholder=""></el-input></td>
            <td><el-input size="small" v-model="item.num" type="text" placeholder=""></el-input></td>
            <td>
                <el-button @click="delStation(index)" type="text" size="small" v-auth="'/plus/stationnum/add_station_num'">删除</el-button>
            </td>
        </tr>
        <el-button size="small" class="el-icon-circle-plus" @click="AddStation()">添加桌号</el-button>
         <div slot="footer" class="dialog-footer mt30">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="submitApi" :loading="loading"
                >确定</el-button
            >
            </div>
        </table>
        
       
    </el-form>
  </el-dialog>
</template>

<script>
import StoreApi from '@/api/store.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: false,
      /*列表数据*/
      tableData: [
        {'name':'','num':1,}
      ],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: '',
        region: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  props: ["open_add", "store_id"],
  created() {
    this.dialogVisible = this.open_add;
    /*获取列表*/
    // this.getTableList();
  },
  methods: {
    handleClick(tab, event) {
        console.log(tab, event);
      },
    
    AddStation(){
      let self = this;
      self.tableData.push({'name':'','num':1,});
    },
    delStation(key){
      let self = this;
      let data =self.tableData;
      
      let newdata = [];
      data.forEach((item,index)=>{
        if(index != key){
          newdata.push(item);
        }
      });
      self.tableData = newdata;
    },
    

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog");
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          StoreApi.deleteShop(
            {
              store_id: row.store_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: '恭喜你，门店删除成功',
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/stationnum/store/dialog/Add.vue